<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_equipe_a">Equipe A (Domicile)</label>
      </div>
      <select id="match_equipe_a"
              v-model="dataForm.equipe_a_id"
              class="custom-select"
              name="match_equipe_a">
        <option :key="equipe.equipe_id"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_equipe_b">Equipe B (Extérieur)</label>
      </div>
      <select id="match_equipe_b"
              v-model="dataForm.equipe_b_id"
              class="custom-select"
              name="match_equipe_b">
        <option :key="equipe.equipe_id"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_date_rencontre">Date et Temps de rencontre</label>
        <label class="input-group-text" for="match_temps_rencontre"></label>
      </div>
      <input id="match_date_rencontre"
             v-model="dataForm.date_rencontre"
             class="form-control"
             name="match_date_rencontre"
             type="date">
      <input id="match_temps_rencontre"
             v-model="dataForm.temps_rencontre"
             class="form-control"
             name="match_temps_rencontre"
             type="time">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_terrain">Terrain</label>
      </div>
      <select id="match_terrain"
              v-model="dataForm.terrain_id"
              class="custom-select"
              name="match_terrain">
        <option :key="terrain.terrain_id"
                :value="terrain.terrain_id"
                v-for="terrain in terrains">
          {{ terrain.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="match_arbitre_principal">Arbitre Principal</label>
      </div>
      <select id="match_arbitre_principal"
              v-model="dataForm.arbitre_principal_id"
              class="custom-select"
              name="match_arbitre_principal">
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_arbitre_assistant_1">Arbitre Assistant 1</label>
      </div>
      <select id="match_arbitre_assistant_1"
              v-model="dataForm.arbitre_assistant_1_id"
              class="custom-select"
              name="match_arbitre_assistant_1">
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_arbitre_assistant_2">Arbitre Assistant 2</label>
      </div>
      <select id="match_arbitre_assistant_2"
              v-model="dataForm.arbitre_assistant_2_id"
              class="custom-select"
              name="match_arbitre_assistant_2">
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_arbitre_commissaire">Arbitre Commissaire</label>
      </div>
      <select id="match_arbitre_commissaire"
              v-model="dataForm.arbitre_commissaire_id"
              class="custom-select"
              name="match_arbitre_commissaire">
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_saison">Saison</label>
      </div>
      <select id="match_saison"
              v-model="dataForm.saison_id"
              class="custom-select"
              name="match_saison">
        <option :key="saison.saison_id"
                :value="saison.saison_id"
                v-for="saison in saisons">
          {{ saison.annee_debut }} - {{ saison.annee_fin  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_championnat">Championnat</label>
      </div>
      <select id="match_championnat"
              v-model="dataForm.championnat_id"
              class="custom-select"
              name="match_championnat">
        <option :key="championnat.championnat_id"
                :value="championnat.championnat_id"
                v-for="championnat in championnats">
          {{ championnat.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_phase">Phase</label>
      </div>
      <select id="match_phase"
              v-model="dataForm.phase"
              class="custom-select"
              name="match_phase">
        <option value="aller">Aller</option>
        <option value="retour">Retour</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="match_journee">Journée</label>
      </div>
      <input id="match_journee"
             v-model="dataForm.journee"
             class="form-control"
             name="match_journee"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      equipes: null,
      terrains: null,
      arbitres: null,
      saisons: null,
      championnats: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        equipe_a_id: '',
        equipe_b_id: '',
        date_rencontre: '',
        temps_rencontre: '',
        terrain_id: '',
        arbitre_principal_id: '',
        arbitre_assistant_1_id: '',
        arbitre_assistant_2_id: '',
        arbitre_commissaire_id: '',
        saison_id: '',
        championnat_id: '',
        phase: '',
        journee: '',
        table: 'matchs_non_joues',
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
    ]),
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Match ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du match !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du match !"
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
          // this.equipes.sort( (a, b) => (a.nom < b.nom) ? -1 : 1)
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'terrains'
    })
        .then((data) => {
          this.terrains = data.data
        })
        .catch((data) => {
          this.terrains = data
        })
    //
    this.axiosGetAllData({
      table: 'arbitres'
    })
        .then((data) => {
          this.arbitres = data.data
        })
        .catch((data) => {
          this.arbitres = data
        })
    //saisons
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //championnats
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > span, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > span.customized-span {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matchs/components/Create.vue